import Vue from 'vue';
import App from './App.vue';

import './assets/css/bootstrap-wrapper.scss';
import './assets/css/tailwind.css';
import './assets/css/main.scss';
import './assets/css/fonts.scss';

import { BootstrapVue, IconsPlugin, ToastPlugin } from 'bootstrap-vue';
import './assets/css/bootstrapCustomization.scss';
import VueCarousel from 'vue-carousel';
import VueHighlightJS from 'vue-highlightjs';
import xml from 'highlight.js/lib/languages/xml';
import java from 'highlight.js/lib/languages/java';
import swift from 'highlight.js/lib/languages/swift';
import bash from 'highlight.js/lib/languages/bash';
import plaintext from 'highlight.js/lib/languages/plaintext';
import 'highlight.js/styles/github.css';
import router from './router';

import store from './store';
import { AuthPlugin } from './auth';
import axios from './axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import VueLogger from 'vuejs-logger';
import * as amplitude from '@amplitude/unified';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMoment from 'vue-moment';
import VueConfetti from 'vue-confetti';
import { VueQueryPlugin } from '@tanstack/vue-query';

Vue.use(VueSweetalert2);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ToastPlugin);
Vue.use(VueConfetti);
Vue.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  },
});

Vue.use(VueCarousel);

Vue.use(VueHighlightJS, {
  languages: {
    xml,
    java,
    swift,
    plaintext,
    bash,
  },
});

Vue.use(store);

Vue.use(VueMoment);

Vue.use(AuthPlugin, {
  onRedirectCallback: (appState) => {
    const userTypeFromCookie = Vue.$cookies.get('userType');

    if (userTypeFromCookie === 'company') {
      router.push(appState && appState.targetUrl ? 'integrations' : window.location.pathname);
    } else {
      router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
    }
  },
});

Vue.use(VueAxios, axios);

Vue.use(VueCookies);

const isLocal = process.env.VUE_APP_ENV === 'local';

const options = {
  isEnabled: isLocal,
  logLevel: isLocal ? 'debug' : 'error',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};

Vue.use(VueLogger, options);

// Add gtag fallback for local development
if (typeof window !== 'undefined' && !window.gtag) {
  window.gtag = function () {};
}

// Add otag fallback for local development
if (typeof window !== 'undefined' && !window.otag) {
  window.otag = function () {};
}

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
    debug: isLocal,
    environment: `${process.env.NODE_ENV}-ui`,
  });
}

amplitude.initAll('9da9a216187e8f2eb0328f6c3f7333ba', {
  serverZone: 'EU',
  analytics: {
    autocapture: {
      attribution: true,
      pageViews: true,
      sessions: true,
    },
  },
  sessionReplay: {
    sampleRate: 1,
    forceSessionTracking: true,
    privacyConfig: {
      blockSelector: [
        '.code-block',
        '.stack-trace-viewer',
        '.stack-trace-frames',
        'pre:has(> code)',
      ],
      defaultMaskLevel: 'conservative',
    },
  },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
